import React from 'react'
import logo from '../myprofile.png';
import resume from '../myresume.pdf'
const Sidebar = () => {

    return (
        <div className="col-2 m-0 p-0" id="profilediv">
            <img src={logo} className="userimage my-3" alt="MyImage" />
            <br />
            <h2 style={{color:"skyblue"}}>Vikash Gupta</h2>
            <h5 style={{color:"skyblue"}}>Web Developer</h5>
            
            <a href={resume} download className="btn btn-outline-light mt-4" id="download_button">Download CV</a>
        </div>
    )
}

export default Sidebar
